import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BaseUrl = process.env.REACT_APP_API_URL;

// Apply for correction
export const applyCorrection = createAsyncThunk(
    'attendanceCorrection/applyCorrection',
    async (correctionData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/AttendanceCorrection/ApplyCorrection`, correctionData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Get user specific corrections
export const getUserCorrections = createAsyncThunk(
    'attendanceCorrection/getUserCorrections',
    async (userId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/AttendanceCorrection/GetUserCorrections/${userId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Get all corrections (Admin)
export const getAllCorrections = createAsyncThunk(
    'attendanceCorrection/getAllCorrections',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/AttendanceCorrection/GetAllCorrections`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Update status (Admin)
export const updateCorrectionStatus = createAsyncThunk(
    'attendanceCorrection/updateCorrectionStatus',
    async ({ id, status, adminNote }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/AttendanceCorrection/UpdateCorrectionStatus/${id}`, { status, adminNote });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const attendanceCorrectionSlice = createSlice({
    name: 'attendanceCorrection',
    initialState: {
        corrections: [],
        allCorrections: [],
        loading: false,
        error: null,
        success: false
    },
    reducers: {
        resetStatus: (state) => {
            state.success = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Apply correction
            .addCase(applyCorrection.pending, (state) => {
                state.loading = true;
            })
            .addCase(applyCorrection.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.corrections.unshift(action.payload.data);
            })
            .addCase(applyCorrection.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Get user corrections
            .addCase(getUserCorrections.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUserCorrections.fulfilled, (state, action) => {
                state.loading = false;
                state.corrections = action.payload.data;
            })
            .addCase(getUserCorrections.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Get all corrections
            .addCase(getAllCorrections.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllCorrections.fulfilled, (state, action) => {
                state.loading = false;
                state.allCorrections = action.payload.data;
            })
            .addCase(getAllCorrections.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update status
            .addCase(updateCorrectionStatus.fulfilled, (state, action) => {
                const index = state.allCorrections.findIndex(c => c._id === action.payload.data._id);
                if (index !== -1) {
                    state.allCorrections[index] = action.payload.data;
                }
            });
    }
});

export const { resetStatus } = attendanceCorrectionSlice.actions;
export default attendanceCorrectionSlice.reducer;
